import { createModuleStrings } from '@platform/core/lib/moduleStrings';
import type { IModuleSummary, Lang } from '@platform/core/types';
import { moduleBundle } from '@platform/i18n';

/**
 * Назва типу запису в однині мовою інтерфейсу («Завдання», «Фракція», «Член комітету») — як recType прототипу v4 у «Нещодавніх змінах»:
 * однина з пакета модуля, без неї — назва типу з каталогу, без каталогу — ключ типу. Чиста функція (читає сховище i18n).
 */
export function typeSingular(summary: IModuleSummary | undefined, recordType: string, lang: Lang): string {
  const rt = summary?.recordTypes.find((r) => r.key === recordType);
  const strings = createModuleStrings(summary?.key ?? '', lang, () => (summary ? moduleBundle(lang, summary.key) : undefined));
  return strings.entity(recordType, 'singular', rt?.name ?? recordType);
}
